export default __webpack_public_path__ + "static/media/ico_closeny.5f415476.svg";